interface SummaryStripProps {
  counts: {
    pending: number;
    confirmed: number;
    "not-found": number;
    "not-sure": number;
  };
}

export function SummaryStrip({ counts }: SummaryStripProps) {
  const parts: { dotClass: string; count: number; label: string }[] = [];

  if (counts.pending > 0)
    parts.push({ dotClass: "border-2 border-[var(--orb-purple)]", count: counts.pending, label: "pending" });
  if (counts.confirmed > 0)
    parts.push({ dotClass: "bg-[var(--orb-green)]", count: counts.confirmed, label: "confirmed" });
  if (counts["not-found"] > 0)
    parts.push({ dotClass: "bg-[var(--orb-gray)]", count: counts["not-found"], label: "not found" });
  if (counts["not-sure"] > 0)
    parts.push({ dotClass: "bg-[var(--orb-amber)]", count: counts["not-sure"], label: "unsure" });

  if (parts.length === 0) return null;

  return (
    <div className="flex gap-3 px-[var(--page-padding)] py-2 text-xs font-semibold text-[var(--orb-text-tertiary)]">
      {parts.map((p) => (
        <span key={p.label} className="flex items-center gap-1">
          <span className={`w-2.5 h-2.5 rounded-full inline-block ${p.dotClass}`} />
          {p.count} {p.label}
        </span>
      ))}
    </div>
  );
}
